import React from 'react'

function Loader() {
  return (
    <div className="loader-container">
        <div className="spinner"></div>
    </div>
  )
}

export default Loader